import React,{useEffect,useState} from 'react'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { toastr } from 'react-redux-toastr';
import api from '../../api';
import { useForm, Controller } from 'react-hook-form';
import 'bootstrap/dist/css/bootstrap.min.css';
import ContainerLoader from '../loader/container-loader';
import styles from '../wallOfFrame/wallOfFrame.module.css'
import { useLocation, useNavigate } from 'react-router-dom';
import {MultiSelect} from 'react-multi-select-component';
import { formatDate } from '../../utils/formatDate';
import { useSelector } from 'react-redux';
import { trackEvent } from '../../utils/gaTracking';

const FlashNewsForm = () => {
  const [isfetching, setIsfetching] = useState(false);
  const [showForm, setShowForm] = useState(true)
  const location = useLocation();
  const { state } = useLocation();
  const navigate = useNavigate();

  const intialData = location.state?.intialData || {};
  const data = location.state?.data || {};
  const currentId = location.state?.currentId || {};
  const sites = location.state?.sites || {};
  const isEdit = state ? state.isEdit : false;
  const authState = useSelector((state) => state.authUser);
//   const role_id = authState?.profile?.role?.role_id;
  const userRoles = authState?.userRoles || [];
  const hasRole = (roleId) => userRoles.some(role => role.role_id === roleId);
  const user_id = authState?.profile?.user_id;
  const user_email = authState?.profile?.email;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control
} = useForm();

  useEffect(() => {
    if (intialData) {
        Object.keys(intialData).forEach((key) => {
            if (key === 'publishdate') {
                const formattedPublishDate = formatDate(intialData.publishdate);
                setValue('publishdate', formattedPublishDate);
            } else if (key === 'expirydate') {
                const formattedExpiryDate = formatDate(intialData.expirydate);
                setValue('expirydate', formattedExpiryDate);
            } else if (key === 'isactive' || key === 'isarchived' || key === 'isinactive') {
                setValue('status_flashnews', intialData.isactive ? '1' : intialData.isarchived ? '2' : intialData.isinactive ? '3' : '');
            } else {
                setValue(key, intialData[key]);
            }
        });
    }
  }, [intialData, setValue]);


  const handleData = async (formData) => {

    if (isEdit) {
        try {
            setIsfetching(true);
            setShowForm(false)
            const request = { resource: `api/flashnews/${currentId}` };
            const editResponse = await api.flashNews.updateFlashNews(request, {
                ...formData,
                isactive: formData.status_flashnews === '1' ? true : false,
                isarchived: formData.status_flashnews === '2' ? true : false,
                isinactive: formData.status_flashnews === '3' ? true : false,
            })
            
            if (editResponse.data.status === 200) {
                toastr.success('Record updated successfully!');
                trackEvent('admin_home_flashnews_update', 'Admin Flashnews Update', 'Admin Flashnews Update', 1, user_id, user_email);
                navigate('/manageflashnews')
            }
            setIsfetching(false);
            
        } catch (error) {
            console.log(error.message)
        }
    } else {
        try {
            const statusMap = {
                1: true, // isActive
                2: true, // isArchive
                3: true, // isApprove
            };
            const statusValue = statusMap[formData.status_flashnews];
            const request = { resource: 'api/flashnews' };
            setIsfetching(true);
            setShowForm(false)
            const res = await api.flashNews.addDetails(request, {
                ...formData,
                isactive: formData.status_flashnews === '1' ? true : false,
                isarchived: formData.status_flashnews === '2' ? true : false,
                isinactive: formData.status_flashnews === '3' ? true : false,
            });

            if (res.data.status === 200) {
                toastr.success('Success', ' Record added Successfully!');
                trackEvent('admin_home_flashnews_add', 'Admin Home Flashnews Add', 'Admin Home Flashnews Add', 1, user_id, user_email);
                setIsfetching(false);
                navigate('/manageflashnews')
                
            } else {
                toastr.error('Error', res.data.message);
            }
            
        } catch (error) {
            console.log(error.message);
        }
    }
    reset();
    setIsfetching(false);
    setShowForm(true)
   
};

const siteOptions = sites.map((site) => ({
    value: site.country,
    label: site.country
}));

    useEffect(() => {
        if (!hasRole(6) && !hasRole(10)) {
            navigate('/home');
        }
    }, [userRoles, navigate]);

  return (
    <div className={`${styles.dataTableWrapper} ${styles.formWrapper} mx-auto p-2`}>
    <h4 className="my-4 pagetitle">Flash News Form</h4>
   {isfetching && <ContainerLoader/>}
   {showForm && <div className='row'>
           <div className='col-12'>
               <div className='walloffame_form w-sm-100 mx-auto'>
               <Form onSubmit={handleSubmit(handleData)} className="d-flex flex-wrap justify-content-between">
           <div className='col-12 col-md-6 p-2'>
               <Form.Group
               className="mb-3"
               controlId="exampleForm.ControlTextarea1"
           >
               <Form.Label>Title<span className='text-danger'>*</span></Form.Label>
               <Form.Control
                   name="title"
                   type='text'
                   {...register('title', { required: 'Title is required' })}
               />
                {errors.title && <p style={{color:'red'}}>{errors.title.message}</p>}
           </Form.Group>
           </div>
           <div className='col-12 col-md-6 p-2'>
               <Form.Group
               className="mb-3"
               controlId="exampleForm.ControlTextarea1"
           >
               <Form.Label>Redirecturl</Form.Label>
               <Form.Control
                   name="redirecturl"
                   type="url"
                   {...register('redirecturl')}
               />
                {errors.redirecturl && <p style={{color:'red'}}>{errors.redirecturl.message}</p>}
           </Form.Group>
           </div>
          
           
           <div className='col-12 col-md-6 p-2'>
               <Form.Group
               className="mb-3"
               controlId="exampleForm.ControlInput1"
           >
               <Form.Label>Publish Date<span className='text-danger'>*</span></Form.Label>
               <Form.Control
                   // onChange={handleChange}
                   type="date"
                   placeholder="Publish Date"
                   name="publishdate"
                   {...register('publishdate', { required: 'Publish Date is required' })}
                   
               />
               {errors.publishdate && <p style={{color:'red'}}>{errors.publishdate.message}</p>}
           </Form.Group>
           </div>
           <div className='col-12 col-md-6 p-2'>
               <Form.Group
               className="mb-3"
               controlId="exampleForm.ControlInput1"
           >
               <Form.Label>Expiry Date<span className='text-danger'>*</span></Form.Label>
               <Form.Control
                   // onChange={handleChange}
                   type="date"
                   placeholder="Expiry Date"
                   name="expirydate"
                   {...register('expirydate', { required: 'Expiry Date is required' })}
                   
               />
               {errors.expirydate && <p style={{color:'red'}}>{errors.expirydate.message}</p>}
           </Form.Group>
           </div>
           <div className='col-12 col-md-6 p-2'>
               <Form.Group>
               <Form.Label>Select Status<span className='text-danger'>*</span></Form.Label>
               <Form.Select
                   name="status_flashnews"
                   {...register('status_flashnews', { required: 'Status is required' })}
                  
                   className="mb-3"
                   aria-label="Default select example"
                   placeholder="Select Type"
               >
                    <option value="">Select Status</option> 
                   <option value="1">Active</option>
                   <option value="2">Archived</option>
                   <option value="3">Inactive</option>
               </Form.Select>
               {errors.status_flashnews && <p style={{color:'red'}}>{errors.status_flashnews.message}</p>}
           </Form.Group>
           </div>
           {/* <div className='col-12 col-md-6 p-2'>
           <Form.Group>
               <Form.Label>Select SiteAccess</Form.Label>
               <Form.Select
                   name="siteaccess"
                   {...register('siteaccess', { required: 'siteaccess is required' })}
                  
                   className="mb-3"
                   aria-label="Default select example"
                   placeholder="Select Type"
               >
                   <option value="">Select SiteAccess</option> 
                   {sites.map((opt,index) => {
                        return <option key={index} value={opt.country}>{opt.country}</option>
                   })}
               </Form.Select>
               {errors.siteaccess && <p style={{color:'red'}}>{errors.siteaccess.message}</p>}
           </Form.Group>
           </div> */}
           <div className='col-12 col-md-6 p-2'>
                <Form.Group>
                    <Form.Label>Select SiteAccess<span className='text-danger'>*</span></Form.Label>
                    <Controller
                       name='siteaccessmulti'
                       control={control}
                       defaultValue={[]}
                       rules={{ required: 'SiteAccess is required' }}
                        render={({ field }) => (
                            <MultiSelect
                                options={siteOptions}
                                value={field.value}
                                onChange={field.onChange}
                                labelledBy="Select"
                            />
                        )}
                    >
                    </Controller>
                    {errors.siteaccessmulti && <p style={{color:'red'}}>{errors.siteaccessmulti.message}</p>}
                </Form.Group>
                </div>
           <div className='d-flex justify-content-end col-12 p-2'>
                <Button variant="secondary" className='me-2' onClick={()=> navigate('/manageflashnews')}>
                     Cancel
                </Button>
                <Button type="reset" variant="secondary" className='mx-2' onClick={()=> reset()}>
                    Reset
                </Button>
                <Button type="submit" variant="primary" className='ms-2'>
                    Save
                </Button>
            </div>
       </Form>
               </div>
           </div>
       </div>}
   

</div>
  )
}

export default FlashNewsForm;
